import "../../CommonImports";
import "../../Core/core.css";
import "./Header.css";
import * as React from "react";
import { TitleSize } from "./Header.Props";
import { Icon } from '../../Icon';
import { css } from '../../Util';
export class HeaderIcon extends React.Component {
    render() {
        let titleSizeClass = undefined;
        switch (this.props.titleSize) {
            case TitleSize.Large:
                titleSizeClass = "l";
                break;
            case TitleSize.Small:
                titleSizeClass = "s";
                break;
            case TitleSize.Medium:
            default:
                titleSizeClass = "m";
        }
        return React.createElement("div", { className: css(this.props.className, "bolt-header-icon", titleSizeClass) }, Icon(this.props.iconProps));
    }
}
